module.exports = __webpack_public_path__ + "img/stijlen-classic.8ab3f3e3.png";